import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { httpService } from '../services/http.service';
import { validSuperAdmin } from '../store/superAdmin/actions/superAdmin.actions';

export function SuperAdminRoute({ children }) {
  const email = useSelector((state) => state.auth?.currentUser?.email);
  const [isAllowed, setIsAllowed] = useState(null); // null = carregando, true = pode acessar, false = redirecionar

  useEffect(() => {
    const verifySuperAdmin = async () => {
      if (!email) {
        setIsAllowed(false);
        return;
      }

      try {
        const result = await validSuperAdmin(email);
        setIsAllowed(result?.isValid === true);
      } catch (err) {
        console.error('Erro ao validar superAdmin:', err);
        setIsAllowed(false);
      }
    };

    verifySuperAdmin();
  }, [email]);

  if (isAllowed === null) {
    return <div>Verificando permissões...</div>; // loading temporário
  }

  return isAllowed ? children : <Navigate to="/" replace />;
}
